// import Arrays from "../Extends/Array";
// import Json from "../Extends/JSON";
// import Strings from "../Extends/String";
// import htmlElement from "../Extends/HTMLElement";
// import htmlTableElement from "../Extends/HTMLTableElement";
// import htmlButtonElement from '../Extends/HTMLButtonElement';
// import htmlInputElement from "../Extends/htmlInputElement";
// import htmlTextAreaElement from "../Extends/HTMLTextAreaElement";

/**
 * @description Classe de ferramentas
 * @author Wellington Pereira
 * @class Tools
 * @since 14/07/2024
 * @version 1.0.0
 */
class Tools {
  /**
 * Converte bytes para KB, MB, etc.
 * 
 * @param {integer} value Quantidade de bytes
 * @param {string} unit Unidade (B | KB | MB | GB | TB | PB | EB | ZB | YB)
 * @returns {string}
 */
  convertBytes(value, unit) {
    if (unit === undefined) {
      unit = 'B';
    }

    let rate = 1024;
    let op;
    switch (unit) {
      case 'B': op = Math.pow(rate, 0); break;
      case 'KB': op = Math.pow(rate, 1); break;
      case 'MB': op = Math.pow(rate, 2); break;
      case 'GB': op = Math.pow(rate, 3); break;
      case 'TB': op = Math.pow(rate, 4); break;
      case 'PB': op = Math.pow(rate, 5); break;
      case 'EB': op = Math.pow(rate, 6); break;
      case 'ZB': op = Math.pow(rate, 7); break;
      case 'YB': op = Math.pow(rate, 8); break;
    }

    let bytes = value * op;
    let units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let unitLevel = 0;
    while (bytes >= 1024) {
      bytes /= 1024;
      unitLevel++;
    }

    return bytes.toFixed(2) + units[unitLevel];
  }

  /**
   * Verifica se o dispositivo é touchscreen
   *  
   * @returns {boolean}
   */
  isTouchScreen() {
    return 'ontouchstart' in document.documentElement;
  }

  maskEmail(email) {
    if (!email || typeof email !== 'string') return '';

    const [user, domain] = email.split('@');
    if (!user || !domain) return email;

    // user: mostra 2 letras, mascara o resto
    const visibleUser = user.slice(0, 2);
    const maskedUser =
      visibleUser + '*'.repeat(Math.max(user.length - 2, 3));

    // domínio: tudo mascarado, mantém TLD
    const domainParts = domain.split('.');
    const tld = domainParts.pop();
    const maskedDomain = '*'.repeat(3);

    return `${maskedUser}@${maskedDomain}.${tld}`;
  }

  resolveTokenExpression(expression) {
    const raw = String(expression || '').trim();
    const safePathPattern = /^[a-zA-Z_$][a-zA-Z0-9_$]*(\.[a-zA-Z_$][a-zA-Z0-9_$]*)*$/;
    if (!safePathPattern.test(raw)) return undefined;

    const parts = raw.split('.');
    let context;

    if (parts[0] === 'this') {
      context = this;
      parts.shift();
    } else if (parts[0] === 'dic' && parts[1] === 'base') {
      context = globalThis?.dic?.base;
      parts.splice(0, 2);
    } else {
      return undefined;
    }

    for (const key of parts) {
      if (context == null) return undefined;
      context = context[key];
    }

    return context;
  }

  /**
   * Retorna o valor correto de um item
   * 
   * @param {mixed} value
   * @returns {string}
   */
  parser(value) {
    if (value === undefined) {
      return undefined;
    }

    if (typeof value === 'function') {
      value = value();
    } else if (typeof value === 'string') {
      let sValue = value.split(' ');
      let date = new Date();

      for (let i = 0; i < sValue.length; i++) {
        const token = String(sValue[i] || '');
        if (token.startsWith('this.') || token.startsWith('dic.base.')) {
          const resolved = this.resolveTokenExpression(token);
          if (resolved !== undefined) {
            sValue[i] = resolved;
          }
        }

        let sValueI = String(sValue[i]).split(' ');
        let sValueILen = sValueI.length;

        for (let j = 0; j < sValueILen; j++) {
          switch (sValueI[j]) {
            case '{YEAR}': sValueI[j] = date.getFullYear(); break;
            case '{MONTH}': sValueI[j] = date.getMonth(); break;
            case '{DATE}': sValueI[j] = date.getDate(); break;
          }
        }
        if (sValueI.length > 1) {
          sValue[i] = sValueI.join(' ');
        } else {
          sValue[i] = sValueI[0];
        }
      }

      if (sValue.length > 1) {
        value = sValue.join(' ');
      } else {
        value = sValue[0];
      }
    }
    return value;
  }

  /**
   * Leitura do DOM
   * 
   * @param {function} callbackFunc 
   */
  ready(callbackFunc) {
    if (document.readyState !== 'loading') {
      // Document is already ready, call the callback directly
      callbackFunc();
    } else if (document.addEventListener) {
      // All modern browsers to register DOMContentLoaded
      document.addEventListener('DOMContentLoaded', callbackFunc);
    } else {
      // Old IE browsers
      document.attachEvent('onreadystatechange', function () {
        if (document.readyState === 'complete') {
          callbackFunc();
        }
      });
    }
  }
}

const tools = new Tools();
export const Extend = () => tools.extend();
export const ConvertBytes = (value, unit) => tools.convertBytes(value, unit);
export const IsTouchScreen = () => tools.isTouchScreen();
export const MaskEmail = (email) => tools.maskEmail(email);
export const Parser = (value) => tools.parser(value);
export const Ready = (callbackFunc) => tools.ready(callbackFunc);
export const ConvertDBDic = (dictionary, key, subKey = null) => tools.convertDBDic(dictionary, key, subKey);